import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ITreasureContract, USDTContarct,NFTContarct,ReserveContract,DepositContract } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import USDTABI from "../abis/USDTABI.json";
import NFTABI from "../abis/NFTABI.json";
import ReserveContarctABI from "../abis/ReserveContarctABI.json";
import DepositAbi from "../abis/DepositAbi.json";


import JoinGG from "../components/JoinGG";
import YourBonusSummary from "../components/YourBonusSummary";
import MyReferralLink from "../components/MyReferralLink";
import Packages from "../components/Packages";
import MLMTree from "../components/MLMTree";
import Loader from "../components/Loader";

const Dashboard = () => {

  const { address, isConnected, status } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [USDTBalance, setUSDTBalance] = useState(null);
  const [BNBBalance, setBNBBalance] = useState(null);
  const [objUser, setObjUser] = useState({});
  const [isJoined, setIsJoined] = useState(false);
  const [objRoyalty, setObjRoyalty] = useState({});
  const [objlevelstats, setObjlevelstats] = useState({});
  const [objReserveBonus, setReserveBonus] = useState({});
  const [objBonus, setObjBonus] = useState({});
  const [objNftBonus, setObjNFTBonus] = useState({});
  const [objReseveTradeBonus, setReseveTradeBonus] = useState({});
  const [objcapping, setObjcapping] = useState({});
  const [objPackageDetails, setPackageDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true); // ✅ Loading State
  const [teamDetails, setTeamDetails] = useState({});
  const [cappingDetails, setCappingDetails] = useState({});

   // ✅ Modal State for Showing Status / Errors
  const [modalStatus, setModalStatus] = useState({
    visible: false,
    type: "", // 'loading', 'success', 'error'
    title: "",
    message: "",
  });
  const [modalPackage, setModalPackage] = useState(null); // Package being purchased

  const onCloseModal = () => setModalStatus({ ...modalStatus, visible: false });

 
    const Joining = async (sponsor, setStatus) => {
      try {
        if (!address) {
          setStatus({
            type: "error",
            title: "Wallet Not Connected",
            message: "Please connect your wallet first.",
          });
          return;
        }
    
        const refferedby = sponsor?.trim();
    
        if (!refferedby) {
          setStatus({
            type: "error",
            title: "Sponsor Missing",
            message: "Please enter sponsor address.",
          });
          return;
        }
    
        const GGTInstance = new web3.eth.Contract(
          ITreasureContractABI,
          ITreasureContract
        );
    
        // 🔍 SPONSOR REGISTERED CHECK
        const sponsorData = await GGTInstance.methods.objUser(refferedby).call();
        if (!sponsorData?.userId || sponsorData?.userId === "0") {
          setStatus({
            type: "error",
            title: "Invalid Sponsor",
            message: "Sponsor is not registered.",
          });
          return;
        }
    
        // 🔄 Show Processing Modal
        setStatus({
          type: "loading",
          title: "Processing…",
          message: "Please confirm the registration in your wallet.",
        });
    
        // 🚀 SEND TX — FULLY TRY-CATCH HANDLED
        const receipt = await GGTInstance.methods
          .register(refferedby)
          .send({ from: address })
          .on("transactionHash", () => {
            setStatus({
              type: "loading",
              title: "Transaction Sent",
              message: "Waiting for blockchain confirmation…",
            });
          });
    
        // 🎉 SUCCESS
        setStatus({
          type: "success",
          title: "Registration Successful",
          message: "You have successfully joined IBullz community.",
        });
    
      setTimeout(async () => {
        await fetchData();  
        setStatus(null);
      }, 2500);
    
      } catch (error) {
        // ❌ ALL ERRORS COME HERE
        let msg = error?.message || "Unexpected error occurred.";
    
        if (msg.includes("denied") || msg.includes("User denied")) {
          msg = "You rejected the transaction.";
        }
    
        setStatus({
          type: "error",
          title: "Transaction Failed",
          message: msg,
        });
    
        setTimeout(() => setStatus(null), 3000);
      }
    };

 
    const PreAuthorize = async (PackageId, USDTValue, setStatusText) => {
      
      try {
        if (!objUser?.userId || objUser.userId == 0) {
          setStatusText({
            visible: true,
            type: "error",
            title: "Not Registered",
            message: "You must join first before purchasing a package.",
          });
    
          setTimeout(() => {
            setStatusText({ visible: false });
            onCloseModal();
          }, 2500);
          return; // Stop execution
        }


       // 🔥 Package-wise Direct & Team Check for 6,7,8
        let qualifiedStatus = true;
        let failMessage = "";
        
        const packageNames = {
          1: "10",
          2: "20",
          3: "50",
          4: "100",
          5: "200",
          6: "400",
          7: "600",
          8: "1000"
        };
        
        const teamIndexMap = {
          6: 4, // Team level index for Package 6
          7: 5, // Team level index for Package 7
          8: 6  // Team level index for Package 8
        };
        
        if ([6, 7, 8].includes(Number(PackageId))) {
          const GGTInstance = new web3.eth.Contract(
            ITreasureContractABI,
            ITreasureContract
          );
          const _team = await GGTInstance.methods.getTeamDetails(address).call();
        
          const totalDirect = _team[0].map(n => Number(n)); // totalDirect[0] = first package direct count
          const noOfTotalTeam = _team[1].map(n => Number(n)); // noOfTotalTeam[x] = team count for each package
        
          const requiredDirect = 4; // Minimum directs for all three packages
          const requiredTeamIndex = teamIndexMap[PackageId];
        
          // Message showing which package’s direct and which package’s team is required
          const directPackageName = packageNames[1]; // first package always for direct
          const teamPackageName = packageNames[requiredTeamIndex+1]; // map index to package
        
          // if (
          //   totalDirect[0] < requiredDirect ||
          //   noOfTotalTeam[requiredTeamIndex] < requiredDirect
          // ) {
          //   qualifiedStatus = false;
        
          //   failMessage = `To buy package $${packageNames[PackageId+1]}, you need minimum ${requiredDirect} direct(s) ` +
          //                 `and minimum ${requiredDirect} team members from Package $${teamPackageName}. ` +
          //                 `You currently have ${totalDirect[0]} direct(s) and ${noOfTotalTeam[requiredTeamIndex]} team members with Package $${teamPackageName} .`;
          // }
        }
        
      if (!qualifiedStatus) {
      setStatusText({
        visible: true,
        type: "error",
        title: "Package Requirements Not Met!",
        message: failMessage,
        persist: true, // stays until user clicks OK
        setStatusText, // pass setter to modal to hide when OK clicked
      });
      return; // Stop execution
    }

        
    // ----------------------------------------------------
    // 🚀 END ELIGIBILITY CHECK
    // ----------------------------------------------------

        const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
    
        const amountInWei = web3.utils.toWei(USDTValue.toString(), "ether");
        const currentAllowance = await USDTInstance.methods
          .allowance(address, ITreasureContract)
          .call();
    
        // 🌟 Already approved: Directly proceed to purchase
        if (window.BigInt(currentAllowance) >= window.BigInt(amountInWei)) {
          setStatusText({
            visible: true,
            type: "loading",
            title: "Processing Purchase…",
            message: "Proceeding with package purchase.",
          });
    
          // Pass the necessary status setters/closers to the next step
          await PurchasePackage(PackageId, setStatusText, onCloseModal);
          return;
        }
    
        // 🌟 Need approval: Request allowance
        setStatusText({
          visible: true,
          type: "loading",
          title: "Approval Pending…",
          message: "Please approve USDT in Wallet.",
        });
    
        // 🚀 Start Approval Transaction
        USDTInstance.methods
          .approve(ITreasureContract, amountInWei)
          .send({ from: address })
          .on("receipt", async () => {
            // --- Approval Success ---
            setStatusText({
              visible: true,
              type: "success",
              title: "Approval Successful!",
              message: "Now confirming your purchase...",
            });
    
            // Immediately follow with the purchase transaction
            await PurchasePackage(PackageId, setStatusText, onCloseModal);
          })
          .on("error", (error) => {
            // --- Approval Transaction Failed/Reverted ---
            setStatusText({
              visible: true,
              type: "error",
              title: "Approval Failed!",
              message: error.message || "Approval transaction failed.",
            });
    
            // ❗ Auto close after showing error
            setTimeout(() => {
              setStatusText({ visible: false });
              onCloseModal(); // Use the close function passed from Dashboard state
            }, 2500);
          })
          .catch((err) => {
            // --- Catch User Rejection / Promise Error ---
            if (err.code === 4001) { // Standard MetaMask user rejection code
                 setStatusText({
                    visible: true,
                    type: "error",
                    title: "Approval Canceled",
                    message: "Transaction rejected by the user.",
                 });
            } else {
                 setStatusText({
                    visible: true,
                    type: "error",
                    title: "Error!",
                    message: err.message || "An unexpected error occurred during approval.",
                 });
            }
    
            setTimeout(() => {
              setStatusText({ visible: false });
              onCloseModal();
            }, 2500);
          });
    
      } catch (error) {
        // --- General Error (e.g., web3 init, allowance check) ---
        setStatusText({
          visible: true,
          type: "error",
          title: "Error!",
          message: error.message || "A general error occurred.",
        });
    
        // ❗ Auto close on general error
        setTimeout(() => {
          setStatusText({ visible: false });
          onCloseModal();
        }, 2500);
      }
    };
    

// In Dashboard.jsx (replace your existing PurchasePackage function with this one)

const PurchasePackage = async (PackageId, setStatusText, onCloseModal) => {
  try {
    const GGTInstance = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
    const allPackageId = [PackageId];

    // 1. Set status to LOADING/PROMPT for the Purchase step
    setStatusText({
      visible: true,
      type: "loading",
      title: "Purchasing Package…",
      message: "Please confirm package purchase in Wallet.",
    });

    // 2. Start Package Purchase Transaction
    GGTInstance.methods.packagePurchase(allPackageId)
      .send({ from: address })
      .on("receipt", async () => {
        // --- Purchase Success ---
        setStatusText({
          visible: true,
          type: "success",
          title: "Package Purchased! 🎉",
          message: "The package has been successfully activated.",
        });
        await new Promise(resolve => setTimeout(resolve, 2000));
        // Refresh data on success
        await fetchData();

        // Auto close the modal after showing success
        setTimeout(() => { 
          setStatusText({ visible: false }); 
          onCloseModal(); 
        }, 2500); 
      })
      .on("error", (error) => {
        // --- Purchase Transaction Failed/Reverted ---
        setStatusText({
          visible: true,
          type: "error",
          title: "Transaction Failed! ❌",
          message: error.message || "The purchase transaction failed or was reverted.",
        });

        // Auto close the modal after showing error
        setTimeout(() => { 
          setStatusText({ visible: false }); 
          onCloseModal(); 
        }, 2500);
      })
      .catch((err) => {
        // --- Catch User Rejection / Promise Error ---
        if (err.code === 4001) { // Standard MetaMask user rejection code
             setStatusText({
                visible: true,
                type: "error",
                title: "Purchase Canceled",
                message: "Transaction rejected by the user.",
             });
        } else {
             setStatusText({
                visible: true,
                type: "error",
                title: "Error!",
                message: err.message || "An unexpected error occurred during purchase.",
             });
        }
        
        // Auto close the modal after showing error
        setTimeout(() => { 
            setStatusText({ visible: false }); 
            onCloseModal(); 
        }, 2500);
      });
  } catch (error) {
    // 3. Handle General Error (e.g., contract object creation failed)
    setStatusText({
      visible: true,
      type: "error",
      title: "General Error! ⚠️",
      message: error.message || "A general error occurred before the transaction started.",
    });

    // Auto close on general error
    setTimeout(() => { 
      setStatusText({ visible: false }); 
      onCloseModal(); 
    }, 2500);
  }
};


  // ✅ Initialize Web3 Once Client/Ethereum Is Ready
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client && client.transport) provider = client.transport;
      else if (typeof window !== "undefined" && window.ethereum)
        provider = window.ethereum;

      if (!provider) {
        setWeb3(null);
        return;
      }

      const w3 = new Web3(provider);
      setWeb3(w3);

      // ✅ Listen For Account OR Chain Changes
      if (provider.on) {
        provider.on("accountsChanged", (accounts) => {
          if (accounts.length > 0) fetchData();
        });

        provider.on("chainChanged", () => {
          if (address) fetchData();
        });
      }
    };

    initWeb3();
  }, [client]);

  // // 🔵 Wallet disconnected → Loader off + UI show
  useEffect(() => {
    if (!isConnected) {
      setIsLoading(false);
    }
  }, [isConnected]);

  // ✅ Fetch User & Balance Data Once Connected
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchData();
    }
  }, [address, isConnected, web3]);

  // ✅ Fetch Function
  const fetchData = async () => {
    try {
      setIsLoading(true); // Start Loading

      const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
      const _USDTBalance = await USDTInstance.methods.balanceOf(address).call();
      setUSDTBalance(web3.utils.fromWei(_USDTBalance, "ether"));

      const _BNBBalance = await web3.eth.getBalance(address);
      setBNBBalance(web3.utils.fromWei(_BNBBalance, "ether"));

      const GGTInstance = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
      const NFTInstance = new web3.eth.Contract(NFTABI, NFTContarct);
      const ReserveInstance = new web3.eth.Contract(ReserveContarctABI, ReserveContract);
     const TradingContractInstance = new web3.eth.Contract(DepositAbi, DepositContract);
      const _objUser = await GGTInstance.methods.objUser(address).call();
      setObjUser({
        userId: _objUser.userId,
        referral: _objUser.referral,
        registrationTimeStamp: _objUser.registrationTimeStamp,
        totalSelfPurchasing: web3.utils.fromWei(_objUser.totalSelfPurchasing, "ether"), 
        lastSelfPurchasing: web3.utils.fromWei(_objUser.lastSelfPurchasing, "ether"), 
        lastPurchasingTimeStamp: _objUser.lastPurchasingTimeStamp,
        totalDirectPurchased: web3.utils.fromWei(_objUser.totalDirectPurchased, "ether"), 
        totalTeamPurchased: web3.utils.fromWei(_objUser.totalTeamPurchased, "ether")
      });

      setIsJoined(_objUser.userId > 0);

      const _objBonus = await GGTInstance.methods.objBonus(address).call();
      setObjBonus({
        totalReferralBonus: web3.utils.fromWei(_objBonus.totalReferralBonus, "ether"),
        totalLevelBonus: web3.utils.fromWei(_objBonus.totalLevelBonus, "ether"),
        totalRoyaltyBonus :web3.utils.fromWei(_objBonus.totalRoyaltyBonus, "ether"),
        totalCreditedBonusUSDT:web3.utils.fromWei(_objBonus.totalCreditedBonusUSDT, "ether"),
        totalWithdrawalBonusUSDT:web3.utils.fromWei(_objBonus.totalWithdrawalBonusUSDT, "ether"),
        totalAvailableBonusUSDT:web3.utils.fromWei(_objBonus.totalAvailableBonusUSDT, "ether"),
        totalRetopupBonusUSDT:web3.utils.fromWei(_objBonus.totalRetopupBonusUSDT, "ether"),
        totalCreditedCapping:web3.utils.fromWei(_objBonus.totalCreditedCapping, "ether"),
      });

       const _cappingDetails = await TradingContractInstance.methods.getTradingIncomeCapping(address).call();
      setCappingDetails({
        tradeFundAmount: web3.utils.fromWei(_cappingDetails.tradeFundAmount, "ether"),
        totalCapping: web3.utils.fromWei(_cappingDetails.totalCapping, "ether"),
        availableCapping :web3.utils.fromWei(_cappingDetails.availableCapping, "ether"),
        achivedCapping:web3.utils.fromWei(_cappingDetails.achivedCapping, "ether"),
        totalDepositFunds:web3.utils.fromWei(_cappingDetails.totalDepositFunds, "ether"),
        activeTrade:(_cappingDetails.activeTrade),
        activeDeposit:web3.utils.fromWei(_cappingDetails.activeDeposit, "ether"),
       
      });


          const _objReserveBonus =
            await ReserveInstance.methods.objBonus(address).call();
          
          setReserveBonus({
            totalNFTLevelBonus: web3.utils.fromWei(
              _objReserveBonus.totalNFTLevelBonus || "0",
              "ether"
            ),
            totalLevelBonus: web3.utils.fromWei(
              _objReserveBonus.totalLevelBonus || "0",
              "ether"
            ),
            totalRoyaltyBonus: web3.utils.fromWei(
              _objReserveBonus.totalRoyaltyBonus || "0",
              "ether"
            ),
            totalCreditedBonusUSDT: web3.utils.fromWei(
              _objReserveBonus.totalCreditedBonusUSDT || "0",
              "ether"
            ),
            totalWithdrawalBonusUSDT: web3.utils.fromWei(
              _objReserveBonus.totalWithdrawalBonusUSDT || "0",
              "ether"
            ),
            totalAvailableBonusUSDT: web3.utils.fromWei(
              _objReserveBonus.totalAvailableBonusUSDT || "0",
              "ether"
            ),
            totalReserveUSDT: web3.utils.fromWei(
              _objReserveBonus.totalReserveUSDT || "0",
              "ether"
            ),
          });

       const _objRoyalty = await GGTInstance.methods.getUserRoyaltyInfo(address).call();
      setObjRoyalty({
        eligible: web3.utils.fromWei(_objRoyalty.eligible, "ether"),
        rank: _objRoyalty.rank,
        totalVolume :web3.utils.fromWei(_objRoyalty.totalVolume, "ether"),
        activeDays:web3.utils.fromWei(_objRoyalty.activeDays, "ether"),
      });

      const _objlevelstats =
        await GGTInstance.methods.getUserLevelStatus(address).call();
      
      setObjlevelstats({
        lastTradeAmount: web3.utils.fromWei(
          _objlevelstats.lastTradeAmount.toString(),
          "ether"
        ),
      
        minutesSinceLastTrade: Number(
          _objlevelstats.minutesSinceLastTrade
        ),
      
        locked: Boolean(_objlevelstats.locked),
      
        lockRemainingMinutes: Number(
          _objlevelstats.lockRemainingMinutes
        ),
      
        lockUntilTimestamp: Number(
          _objlevelstats.lockUntilTimestamp
        ),
      });


      const _objNftBonus = await NFTInstance.methods.objBonus(address).call();
      setObjNFTBonus({
        totalNFTOwnerBonus: web3.utils.fromWei(_objNftBonus.totalNFTOwnerBonus, "ether"),
        totalReserveBonus: web3.utils.fromWei(_objNftBonus.totalReserveBonus, "ether"),
        totalLevelBonus    :web3.utils.fromWei(_objNftBonus.totalLevelBonus , "ether"),
        totalRoyaltyBonus   :web3.utils.fromWei(_objNftBonus.totalRoyaltyBonus, "ether"),
        totalCreditedBonusUSDT     :web3.utils.fromWei(_objNftBonus.totalCreditedBonusUSDT, "ether"),
        totalCreditedTodayCapping :web3.utils.fromWei(_objNftBonus.totalCreditedTodayCapping, "ether"),
         totalNFTInSell: Number(
          _objNftBonus.totalNFTInSell
        ),
        NFTTradeFeeCollectReturn :web3.utils.fromWei(_objNftBonus.NFTTradeFeeCollectReturn, "ether"),

      });

       const _objReserveTradeBonus = await ReserveInstance.methods.userData(address).call();
      setReseveTradeBonus({
        totalContributed: web3.utils.fromWei(_objReserveTradeBonus.totalContributed, "ether"),
        totalReceived: web3.utils.fromWei(_objReserveTradeBonus.totalReceived, "ether"),
      });
      

      //  Corrected getUserCappingStatus mapping
      const _objCapping = await NFTInstance.methods.getUserCappingStatus(address).call();
      setObjcapping({
        totalCapping: web3.utils.fromWei(_objCapping.totalCapping, "ether"),
        usedCapping: web3.utils.fromWei(_objCapping.usedCapping, "ether"),
        availableCapping: web3.utils.fromWei(_objCapping.availableCapping, "ether"),
      });

 

      const _objPackageDetails = await GGTInstance.methods.getPackagePurchaseDetails(address).call();
      console.log("Contract Raw Data:", _objPackageDetails);
      console.log("Index 0 → purchasedPackage:", _objPackageDetails[0]);
console.log("Index 1 → purchasedTimestamp:", _objPackageDetails[1]);
console.log("Index 2 → expiryTimestamp:", _objPackageDetails[2]);
console.log("Index 3 → noofTimesPurchased:", _objPackageDetails[3]);
            setPackageDetails({
              purchasedPackage: _objPackageDetails[0].map(v => v === true || v === "true"),
        purchasedTimestamp: _objPackageDetails[1].map(v => Number(v)),
        expiryTimestamp: _objPackageDetails[2].map(v => Number(v)),
        noofTimesPurchased: _objPackageDetails[3].map(v => Number(v)),

      });

    } 
    catch (error) {
      console.error("Error Fetching Data:", error);
    } 
    finally {
      setIsLoading(false); // Stop Loading Regardless of Success/Failure
    }
  };

  // ✅ Show Loader While Data Is Being Fetched
  if (isLoading) {
    return (
      <Loader />
    );
  }

  // ✅ Once DataIs Ready, Render Components Safely
  return (

    <div>
      {status === "connected" ? (
        <>
          <MyReferralLink address={address} isJoined={isJoined} objUser={objUser}/>
          <JoinGG Joining={Joining} isJoined={isJoined} />
          <YourBonusSummary objUser={objUser} objBonus={objBonus} objReserveBonus={objReserveBonus} objlevelstats={objlevelstats} objRoyalty={objRoyalty}objNftBonus={objNftBonus} objcapping={objcapping} cappingDetails={cappingDetails} objReseveTradeBonus={objReseveTradeBonus} USDTBalance={USDTBalance}/>
          <Packages objPackageDetails={objPackageDetails} PreAuthorize={PreAuthorize} PurchasePackage={PurchasePackage}  />
          <MLMTree address={address} web3={web3} />
        </>
      ) : (
        <>
          <MyReferralLink address={address} isJoined={isJoined} objUser={objUser} />
          <JoinGG Joining={Joining} isJoined={isJoined} />
          <YourBonusSummary objUser={objUser} objBonus={objBonus} objReserveBonus={objReserveBonus} objlevelstats={objlevelstats} objRoyalty={objRoyalty} objNftBonus={objNftBonus} objcapping={objcapping} cappingDetails={cappingDetails} objReseveTradeBonus={objReseveTradeBonus} USDTBalance={USDTBalance}/>
          <Packages objPackageDetails={objPackageDetails} PreAuthorize={PreAuthorize} PurchasePackage={PurchasePackage}  />
          <MLMTree address={address} web3={web3} />
        </>
      )}
    </div>
  );
};

export default Dashboard;
